import $ from 'jquery';

// Import utilities
const {
	isDefined
} = _uo.utility;

class ItemHeaderIcon {
	constructor( integrationCode ){
		this.integrationCode = integrationCode;

		return this.createItemIcon();
	}

	/**
	 * Create item icon
	 *
	 * @since 0.5
	 *
	 * @return {object}   HTML with the item icon
	 */

	createItemIcon(){
		const $icon = document.createElement( 'div' );
		$icon.classList.add( 'uap-item-icon' );

		if ( isDefined( UncannyAutomator.integrations[ this.integrationCode ] ) ){
			// Get integration by integrationCode
			let integration = UncannyAutomator.integrations[ this.integrationCode ];

			// Check if it has a svg image
			if ( isDefined( integration.icon_svg ) ){
				$icon.insertAdjacentHTML( 'beforeEnd', `
					<img src="${ integration.icon_svg }" alt="${ integration.name }">
				` );
			} else if ( isDefined( integration.icon_32 ) && isDefined( integration.icon_64 ) ){
				// Check if it has a png image
				$icon.insertAdjacentHTML( 'beforeEnd', `
					<img 
						src="${ integration.icon_32 }"  
						alt="${ integration.name }"
					>
				` );
			}
		} 

		// Return element
		return $icon;
	}
}

export default ItemHeaderIcon;